import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-submit-btn"
export default class extends Controller {
  static targets = ["input", "submit"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isEmpty = !this.inputTarget.value.trim() && !this.hasFiles()
    this.submitTarget.disabled = isEmpty
    
    if (isEmpty) {
      this.submitTarget.classList.add("cursor-not-allowed", "opacity-50")
      this.submitTarget.classList.remove("cursor-pointer")
    } else {
      this.submitTarget.classList.remove("cursor-not-allowed", "opacity-50")
      this.submitTarget.classList.add("cursor-pointer")
    }
  }

  hasFiles() {
    const form = this.element.closest('form') || this.element
    return Array.from(form.querySelectorAll('input[type="hidden"][name="chat_message[files][]"]')).some(i => i.value)
  }
}

